module.exports = __webpack_public_path__ + "img/ic-notification.785dbca9.png";